import React, { Component } from 'react';
import ClassNames from 'classnames';
import './modal.scss';

class Modal extends Component {
    render() {

        const modalClasses = {
            "modal-wrapper" : true,
            "visible": this.props.visible
        };

        let closeModalButton = null;

        if (this.props.onClose) {
            closeModalButton = <button className="modal-action close" onClick={this.props.onClose}/>;
        }

        return (
            <div className={ClassNames(modalClasses)} onClick={this.props.onClose}>
                <div className="modal-content-wrapper">
                    {closeModalButton}
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Modal;
